export default __webpack_public_path__ + "static/media/planless.400161ab.svg";